import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* istanbul ignore file */
// ABOVE: requesting Jest to ignore this file.

import { client } from '@chegg/checkout-sdk';
import { getCheggTldFrom, isWindowDefined } from '@chegg/utils';
import { Environment } from '../common/interfaces';
var getUrl = function getUrl(env, queryParams) {
  if (env !== Environment.PRODUCTION && env !== Environment.STAGING && queryParams !== null && queryParams !== void 0 && queryParams.dev) {
    var bffEndpoint = queryParams.BFF_PORT ? "http://localhost:".concat(queryParams.BFF_PORT, "/graphql") : 'http://localhost:3005/graphql';
    console.log('Checkout Contentful Bff is now pointing to 🚀 ', bffEndpoint);
    return bffEndpoint;
  }
  var hostname;
  if (isWindowDefined) {
    hostname = window.location.hostname;
  }
  var tld = hostname && getCheggTldFrom(hostname) ? getCheggTldFrom(hostname) : '.com';
  switch (env) {
    case Environment.DEVELOPMENT:
      return "https://gateway.test.cheggnet".concat(tld, "/checkout-contentful-bff/graphql");
    case Environment.TEST:
      return "https://gateway.test.cheggnet".concat(tld, "/checkout-contentful-bff/graphql");
    case Environment.STAGING:
      return "https://gateway.stage.chegg".concat(tld, "/checkout-contentful-bff/graphql");
    case Environment.PRODUCTION:
      return "https://gateway.chegg".concat(tld, "/checkout-contentful-bff/graphql");
    default:
      return "https://gateway.test.cheggnet".concat(tld, "/checkout-contentful-bff/graphql");
  }
};
var API = /*#__PURE__*/function () {
  function API() {
    _classCallCheck(this, API);
  }
  return _createClass(API, null, [{
    key: "getContent",
    value: function () {
      var _getContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, env, queryParams) {
        var content, gqlResponse, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              content = {
                error: '',
                data: null
              };
              _context.prev = 1;
              _context.next = 4;
              return fetch(getUrl(env, queryParams), {
                method: 'POST',
                headers: {
                  'content-type': 'application/json'
                },
                body: JSON.stringify({
                  query: query,
                  queryParams: queryParams
                })
              });
            case 4:
              gqlResponse = _context.sent;
              _context.next = 7;
              return gqlResponse.json();
            case 7:
              res = _context.sent;
              _context.next = 10;
              return res.data;
            case 10:
              content.data = _context.sent;
              _context.next = 13;
              return res.errors;
            case 13:
              _context.t0 = _context.sent;
              if (!_context.t0) {
                _context.next = 16;
                break;
              }
              _context.t0 = res.errors[0].message;
            case 16:
              content.error = _context.t0;
              return _context.abrupt("return", content);
            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](1);
              content.error = _context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message;
              return _context.abrupt("return", content);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 20]]);
      }));
      function getContent(_x, _x2, _x3) {
        return _getContent.apply(this, arguments);
      }
      return getContent;
    }()
  }, {
    key: "authorize",
    value: function authorize(params) {
      return client.authorize(params);
    }

    // for OneClick
  }, {
    key: "resume",
    value: function resume(params) {
      return client.checkoutAPI.resume(params);
    }
  }, {
    key: "undoCancel",
    value: function undoCancel(params) {
      return client.checkoutAPI.undoCancel(params);
    }
  }]);
}();
export { API as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/api/index.js
// module id = 1323
// module chunks = 11